/**
 * Curriculum names arrive HTML-encoded from the database, so rendering one
 * directly shows the student a literal "Use &lt;, &gt; and = to compare
 * numbers up to 100". Only a handful of rows are affected, and they are the
 * inequality and comparison skills whose names need those characters.
 *
 * Decoding through the DOM also strips stray markup, which is what a label
 * wants; dangerouslySetInnerHTML would render database content as live HTML in
 * front of a student. Falls back to the raw string when there is no DOM.
 *
 * The tutor app has its own copy in
 * `tutor-frontend/src/modules/bmd/utils/formatters.ts`. The two frontends are
 * separate builds with no shared package, so this is duplicated deliberately.
 */
export function plainText(value: string | null | undefined): string {
  if (!value) return ""
  if (typeof document === "undefined") return String(value)
  const tmp = document.createElement("div")
  tmp.innerHTML = String(value)
  return (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim()
}
